var DepositFixForm = {

    host: "https://app.depositfix.com/",
    s3Host: "https://depositfix.s3.amazonaws.com/",
    cssFile: "",
    hubSpotFormId: "",
    userId: "",
    portalId: "",
    paymentType: "SINGLE_PAYMENT",
    productName: "",
    amount: "",
    discountAmount: 0,
    discountPercent: 0,
    currency: "USD",
    currencySign: "$",
    paypalEmail: "",
    discount: false,
    discountId: "",
    planInterval: "",
    hubspotForm: {},
    submitBtnText: "Buy Now",
    mode: "",
    redirectUrl: "",
    fallbackRedirectUrl: "https://help.depositfix.com/article/14-setup-redirect-after-payment",
    lambdaUrl: "https://9j11ty5tq3.execute-api.us-east-1.amazonaws.com/prod",
    loggerUrl: "https://woetzkq6v6.execute-api.us-east-1.amazonaws.com/prod",
    hsContext: {},
    followUpEmailId: "",
    followUpEmailCampaignId: "",
    callback: function () {
    },
    beforeSubmitCallback: function () {
    },
    currencySymbols: {
        'USD': '$', // US Dollar
        'EUR': '€', // Euro
        'SEK': 'kr', // Swedish Krona
        'CRC': '₡', // Costa Rican Colón
        'GBP': '£', // British Pound Sterling
        'ILS': '₪', // Israeli New Sheqel
        'INR': '₹', // Indian Rupee
        'JPY': '¥', // Japanese Yen
        'KRW': '₩', // South Korean Won
        'NGN': '₦', // Nigerian Naira
        'PHP': '₱', // Philippine Peso
        'PLN': 'zł', // Polish Zloty
        'PYG': '₲', // Paraguayan Guarani
        'THB': '฿', // Thai Baht
        'UAH': '₴', // Ukrainian Hryvnia
        'VND': '₫', // Vietnamese Dong
        'RUB': '₽', // Russian Ruble
        'AUD': 'AUD ', // Australian
        'CAD': 'CAD ', // Canadian,
        'NZD': 'NZD ', // New Zealand
        'CHF': 'CHF ' // New Zealand
    },

    init: function (params) {
        if (location.protocol !== 'https:') {
            alert("PayPal requires payment page to be loaded with https. How to setup SSL with HubSpot: https://knowledge.hubspot.com/website-user-guide/how-to-set-up-ssl-for-a-hubspot-website");
            return false;
        }
        if (params.cssFile !== undefined || params.cssFile === null) {
            DepositFixForm.cssFile = params.cssFile;
        } else {
            DepositFixForm.cssFile = DepositFixForm.s3Host + "depositfix.css";
        }
        DepositFixForm.hubSpotFormId = params.hubSpotFormId;
        DepositFixForm.userId = params.userId;
        if (params.portalId) {
            DepositFixForm.portalId = params.portalId;
        }
        DepositFixForm.paypalEmail = params.paypalEmail;
        if (params.paymentType) {
            DepositFixForm.paymentType = params.paymentType;
        }
        DepositFixForm.productName = params.productName;
        DepositFixForm.setAmountParameters(params);
        if (params.currency) {
            DepositFixForm.currency = params.currency;
        }
        if (DepositFixForm.currency && DepositFixForm.currencySymbols[DepositFixForm.currency.toUpperCase()]) {
            DepositFixForm.currencySign = DepositFixForm.currencySymbols[DepositFixForm.currency.toUpperCase()];
        }
        if (params.discount) {
            DepositFixForm.discount = params.discount;
        }
        DepositFixForm.planInterval = DepositFixForm.mapToPayPalPlanInterval(params.planInterval);
        DepositFixForm.mode = params.mode;
        DepositFixForm.redirectUrl = params.redirectUrl;
        if (params.followUpEmailId) {
            DepositFixForm.followUpEmailId = params.followUpEmailId;
        }
        if (params.followUpEmailCampaignId) {
            DepositFixForm.followUpEmailCampaignId = params.followUpEmailCampaignId;
        }
        if (params.callback) {
            DepositFixForm.callback = params.callback;
        }
        if (params.beforeSubmitCallback) {
            DepositFixForm.beforeSubmitCallback = params.beforeSubmitCallback;
        }
        DFUtils.loadAllCss(DepositFixForm.cssFile);
        DFUtils.loadJS("https://ajax.googleapis.com/ajax/libs/jquery/3.1.0/jquery.min.js", DepositFixForm.loadScripts);
    },

    setAmountParameters: function(params) {
        switch (DepositFixForm.paymentType) {
            case "SINGLE_PAYMENT":
                DepositFixForm.amount = params.amount;
            break;
            case "SUBSCRIPTION":
                DepositFixForm.amount = params.subscriptionAmount;
                DepositFixForm.subscriptionAmount = params.subscriptionAmount;
                break;
            case "SINGLE_PAYMENT_SUBSCRIPTION":
                DepositFixForm.amount = params.amount;
                DepositFixForm.subscriptionAmount = params.subscriptionAmount;
                break;
            default:
                break;
        }
    },

    loadScripts: function() {
        $.when(
            $.getScript("https://cdn.depositfix.com/js/hs-form-v2.js"),
            $.getScript("https://ajax.aspnetcdn.com/ajax/jquery.validate/1.14.0/jquery.validate.min.js"),
            $.Deferred(function (deferred) {
                $(deferred.resolve);
            })
        ).done(function () {
            $("#df-script").after("<div id='df-card-container'></div>");
            DepositFixForm.initUserSettings();
        });
    },

    initUserSettings: function() {
        var url = DepositFixForm.url.getStripeDetails();
        if (DepositFixForm.mode) {
            url += "&mode=" + DepositFixForm.mode;
        }
        $.get(url, function (data) {
            DepositFixForm.portalId = data.portalId;
            DepositFixForm.initHubSpotForm();
        })
        .fail(function (result) {
            var errorMessage = "Depositfix server is not available";
            if (result.responseJSON) {
                errorMessage = result.responseJSON.errorMessage;
            }
            var html = "<div class='df-title'>" + errorMessage + "</div>";
            $("#df-card-container").prepend(html);
        });
        DFUtils.initGlobalLogger();
    },

    initHubSpotForm: function() {
        hbspt.forms.create({
            portalId: DepositFixForm.portalId,
            formId: DepositFixForm.hubSpotFormId,
            target: "#df-card-container",
            inlineMessage: "Submitted",
            onFormReady: function ($form, ctx) {
                DepositFixForm.initTitles();
                DepositFixForm.hubspotForm = $form;
                DepositFixForm.postInit();
                DepositFixForm.showDiscountCodeField($form);
                DepositFixForm.createPayPalButton($form);
                DepositFixForm.attachPayPalButtonHandler();
                DepositFixForm.initPayPalForm();
                $("#df-card-container").append($(DFTemplate.createFooter(DepositFixForm.amount)));
            },
            onFormSubmit: function($form) {
                return false;
            }
        });
    },

    initTitles: function() {
        var html = "<div class='df-title'>" + DepositFixForm.productName + " - " + DepositFixForm.currencySign + DepositFixForm.amount + "</div>";
        $("#df-card-container").prepend(html);
    },

    postInit: function() {
        DepositFixForm.loadContext();
        DepositFixForm.setupRedirectUrl();
        DepositFixForm.callback();
        DFUtils.loadJS(DepositFixForm.lambdaUrl + '/js?form=' + DepositFixForm.hubSpotFormId);
    },

    createPayPalButton: function(hubSpotForm) {
        hubSpotForm.find(".hs_submit .hs-button")
            .attr("id", "paypal-btn")
            .attr("type", "image")
            .attr("src", "https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-medium.png")
            .css("background-image", "none")
            .css("background-color", "#ffba1b")
            .css("width", "170px")
            .css("height", "32px")
            .css("padding", "0px")
            .css("border", "0px")
            .attr("title", "Check out with PayPal");
    },

    attachPayPalButtonHandler: function() {
        $(".hs-button").click(function(e) {
            DepositFixForm.beforeSubmitCallback();
            DFUtils.startProgress();
            DepositFixForm.globalSubmit(e);
            e.stopPropagation();
            return false;
        });
    },

    initPayPalForm: function() {
        var payPalForm;
        switch (DepositFixForm.paymentType) {
            case "SINGLE_PAYMENT":
                payPalForm = DepositFixForm.createPayPalSinglePaymentForm();
                break;
            case "SUBSCRIPTION":
                payPalForm = DepositFixForm.createPayPalSubscriptionForm();
                break;
            case "SINGLE_PAYMENT_SUBSCRIPTION":
                payPalForm = DepositFixForm.createPayPalSinglePaymentSubscriptionForm();
                break;
            default:
                break;
        }
        $("#df-card-container").append($(payPalForm));
    },

    createPayPalSinglePaymentForm: function() {
        var paypalForm = 
            "<form action='" + DepositFixForm.url.getPayPalFormUrl() + "' method='post' id='df_paypalform'>" +
                "<input type='hidden' name='cmd' value='_xclick'/>" +
                "<input type='hidden' name='business' value='" + DepositFixForm.paypalEmail + "'/>" +
                "<input type='hidden' name='notify_url' value='" + DepositFixForm.url.getPayPalNotifyUrl() + "'/>" +
                "<input type='hidden' name='return' value='" + DepositFixForm.redirectUrl + "'/>" +
                "<input type='hidden' name='amount' value='" + (DepositFixForm.finalAmount != undefined ? DepositFixForm.finalAmount : DepositFixForm.amount) + "'/>" +
                "<input type='hidden' name='email' id='paypal_email'/>" +
                "<input type='hidden' name='first_name'/>" +
                "<input type='hidden' name='last_name'/>" +
                "<input type='hidden' name='item_name' value='" + DepositFixForm.productName + "'/>" +
                "<input type='hidden' name='currency_code' value='" + DepositFixForm.currency + "'/>" +
                "<input type='hidden' name='custom' id='paypal_custom_data'/>" +
            "</form>";
            return paypalForm;
    },

    createPayPalSubscriptionForm: function() {
        var paypalForm = 
            "<form action='" + DepositFixForm.url.getPayPalFormUrl() + "' method='post' id='df_paypalform'>" +
                "<input type='hidden' name='cmd' value='_xclick-subscriptions'/>" +
                "<input type='hidden' name='business' value='" + DepositFixForm.paypalEmail + "'/>" +
                "<input type='hidden' name='notify_url' value='" + DepositFixForm.url.getPayPalNotifyUrl() + "'/>" +
                "<input type='hidden' name='return' value='" + DepositFixForm.redirectUrl + "'/>" +
                "<input type='hidden' name='rm' value='1'/>" +
                "<input type='hidden' name='a3' value='" + DepositFixForm.subscriptionAmount + "'/>" +
                "<input type='hidden' name='t3' value='" + DepositFixForm.planInterval + "'/>" +
                "<input type='hidden' name='p3' value='1'/>" +
                "<input type='hidden' name='src' value='1'/>" +
                "<input type='hidden' name='sra' value='1'/>" +
                "<input type='hidden' name='email' id='paypal_email'/>" +
                "<input type='hidden' name='first_name' />" +
                "<input type='hidden' name='last_name' />" +
                "<input type='hidden' name='item_name' value='DepositFix Subscription'/>" +
                "<input type='hidden' name='currency_code' value='USD'/>" +
                "<input type='hidden' name='no_note' value='1'/>" +
                "<input type='hidden' name='custom' id='paypal_custom_data'/>" +
            "</form>";
            return paypalForm;
    },

    createPayPalSinglePaymentSubscriptionForm: function() {
        var paypalForm = 
            "<form action='" + DepositFixForm.url.getPayPalFormUrl() + "' method='post' id='df_paypalform'>" +
                "<input type='hidden' name='cmd' value='_xclick-subscriptions'/>" +
                "<input type='hidden' name='business' value='" + DepositFixForm.paypalEmail + "'/>" +
                "<input type='hidden' name='notify_url' value='" + DepositFixForm.url.getPayPalNotifyUrl() + "'/>" +
                "<input type='hidden' name='return' value='" + DepositFixForm.redirectUrl + "'/>" +
                "<input type='hidden' name='rm' value='1'/>" +
                "<input type='hidden' name='a1' value='" + DepositFixForm.amount + "'/>" +
                "<input type='hidden' name='t1' value='" + 'D' + "'/>" +
                "<input type='hidden' name='p1' value='1'/>" +
                "<input type='hidden' name='a3' value='" + DepositFixForm.subscriptionAmount + "'/>" +
                "<input type='hidden' name='t3' value='" + DepositFixForm.planInterval + "'/>" +
                "<input type='hidden' name='p3' value='1'/>" +
                "<input type='hidden' name='src' value='1'/>" +
                "<input type='hidden' name='sra' value='1'/>" +
                "<input type='hidden' name='email' id='paypal_email'/>" +
                "<input type='hidden' name='first_name' />" +
                "<input type='hidden' name='last_name' />" +
                "<input type='hidden' name='item_name' value='DepositFix Subscription'/>" +
                "<input type='hidden' name='currency_code' value='USD'/>" +
                "<input type='hidden' name='no_note' value='1'/>" +
                "<input type='hidden' name='custom' id='paypal_custom_data'/>" +
            "</form>";
            return paypalForm;
    },

    deleteAndRenderPayPalForm: function() {
        $("#df_paypalform").remove();
        DepositFixForm.initPayPalForm();
    },

    showDiscountCodeField: function(hubSpotForm) {
        if (DepositFixForm.discount && DepositFixForm.paymentType == 'SINGLE_PAYMENT') {
            hubSpotForm.find(".hs_submit").prepend(DFTemplate.createDiscountCode());
            $(".df-discount-area").show();
            DepositFixForm.attachDiscountChecker();
        }
    },

    attachDiscountChecker: function() {
        $("#apply-discount-btn").click(function () {
            DepositFixForm.clearDiscountInfo();
            var code = $("#df-discount-code").val();
            if (code) {
                var url = DepositFixForm.url.getDiscount() + "&code=" + code;
                $.get(url)
                    .done(function(result) {
                        if (result.percent === 100) {
                            DepositFixForm.hidePaymentFields();
                        } else {
                            DepositFixForm.showPaymentFields();
                        }
                        DepositFixForm.applyDiscount(result);
                    }).fail(function(result) {
                        if (!DepositFixForm.couponId) {
                            DepositFixForm.showPaymentFields();
                            $("#df-discount-result").text("Discount code not found");
                            DepositFixForm.deleteAndRenderPayPalForm();
                        }
                    });
            } else {
                DepositFixForm.deleteAndRenderPayPalForm();
            }
            return false;
        });
    },

    clearDiscountInfo: function() {
        DepositFixForm.finalAmount = DepositFixForm.amount;
        DepositFixForm.discountAmount = 0;
        DepositFixForm.discountPercent = 0;
        DepositFixForm.discountId = "";
        var moneyFormatted = DFUtils.formatMoney(DepositFixForm.finalAmount);
        $(".df-title").html(DepositFixForm.productName + " - " + moneyFormatted);
        $("#df-final-amount").html(moneyFormatted);
        $("#df-discount-result").html("");
    },

    hidePaymentFields: function() {
        $('.df-payment-field').hide();
    },

    showPaymentFields: function() {
        $('.df-payment-field').show();
    },

    applyDiscount: function(discount) {
        if (discount.amount !== null) {
            DepositFixForm.discountAmount = discount.amount;
            DepositFixForm.finalAmount = Math.max(0, DFUtils.toTwoDec(DepositFixForm.amount - DepositFixForm.discountAmount));
        }
        else {
            DepositFixForm.discountPercent = discount.percent;
            DepositFixForm.finalAmount = Math.max(0, DFUtils.toTwoDec(DepositFixForm.amount
                - (DepositFixForm.amount * Number(DepositFixForm.discountPercent) * .01)));
        }
        DepositFixForm.discountId = discount.id;
        DepositFixForm.discountAppliedMessage();
        DepositFixForm.hidePaymentTotalDiscount();
        DepositFixForm.deleteAndRenderPayPalForm();
    },

    discountAppliedMessage: function() {
        var html = DepositFixForm.productName + " - " + DepositFixForm.currencySign + DepositFixForm.finalAmount;
        if (DepositFixForm.discountAmount) {
            html = html + " (-" + DepositFixForm.currencySign + DepositFixForm.discountAmount + " discount)";
            $("#df-discount-result").html("Discount of " + DepositFixForm.currencySign + DepositFixForm.discountAmount + " applied.");
        } else if (DepositFixForm.discountPercent) {
            html = html + " (-" + DepositFixForm.discountPercent + "%" + " discount)";
            $("#df-discount-result").html("Discount of " + DepositFixForm.discountPercent + "%" + " applied.");
        }
        $(".df-title").html(html);
        $("#df-final-amount").html(DFUtils.formatMoney(DepositFixForm.finalAmount));
    },

    hidePaymentTotalDiscount: function() {
        if (DepositFixForm.finalAmount === 0 || DepositFixForm.discountPercent === 100) {
            DepositFixForm.hidePaymentFields();
        }
        else {
            DepositFixForm.showPaymentFields();
        }
    },

    globalSubmit: function (e) {
        DFUtils.startProgress();
        DFUtils.valid(function(valid){
            if (valid) {
                DepositFixForm.submitDepositFix();
            } else {
                DFUtils.stopProgress();
            }
        });
    },

    submitDepositFix: function () {
        var url = DepositFixForm.url.getDepositFixSubmit();
        var data = {
            "hsFormId": DepositFixForm.hubSpotFormId,
            "hscontext": JSON.stringify(DepositFixForm.hsContext),
            "allParams": [{}],
            "files": []
        };
        var form = DepositFixForm.hubspotForm;
        var formInputsArray = form.serializeArray();
        $.each(formInputsArray, function(i, field) {
            if (data["allParams"][0][field.name]) {
                if (!(data["allParams"][0][field.name] instanceof Array)) {
                    var temp = data["allParams"][0][field.name];
                    data["allParams"][0][field.name] = [temp];
                }
                data["allParams"][0][field.name].push(field.value);
            } else {
                data["allParams"][0][field.name] = field.value;
            }
        });
        DFUtils.hideError();
        if (!DepositFixForm.doesFormContainFileFields(form[0])) {
            DepositFixForm.submitForm(url, data);
        } else {
            DepositFixForm.convertAllFilesToBytesAndSubmitForm(form[0], url, data);
        }
    },

    doesFormContainFileFields: function(fields) {
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].type == 'file' && fields[i].files[0]) {
                return true;
            }
        }
        return false;
    },

    convertAllFilesToBytesAndSubmitForm: function(form, url, data) {
        var promises = [];
        $.each(form, function(i, field) {
            if (field.type == 'file' && field.files[0]) {
                promises.push(DepositFixForm.convertFileToBytes(data, field));
            }
        });
        Promise.all(promises).then(function() {
            DepositFixForm.submitForm(url, data);
        });
    },

    convertFileToBytes: function(data, field) {
        return new Promise(function(resolve, reject) {
            var fileReader = new FileReader();
            var file = field.files[0];
            fileReader.onloadend = function() {
                var fileObject = {
                    fieldName: field.name,
                    fileName: file.name,
                    bytes: btoa(fileReader.result)
                };
                data["files"].push(fileObject);
                resolve();
            };
            fileReader.readAsBinaryString(file);
        });
    },

    submitForm: function(url, data) {
        $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json; charset=utf-8",

            success: function (response) {
                DFUtils.logMessage("Submitting the form", data);
                if (DepositFixForm.isFreeOfCharge()) {
                    window.location.href = DepositFixForm.redirectUrl;
                    return;
                }
                DepositFixForm.updatePayPalInputValues();
                $("#df_paypalform").submit();
            }, error: function (response) {
                var errorMessage = "Something went wrong, please try to reload the page";
                if (response.responseJSON && response.responseJSON.errorMessage) {
                    errorMessage = response.responseJSON.errorMessage;
                }
                DFUtils.showError(errorMessage);
                DFUtils.logMessage("Submit to DepositFix error", response);
            }
        });
    },

    isFreeOfCharge: function() {
        return (DepositFixForm.finalAmount != undefined && DepositFixForm.finalAmount == 0) || DepositFixForm.amount == 0;
    },

    loadContext: function () {
        DepositFixForm.formContext = JSON.parse(
            DepositFixForm.hubspotForm.find("[name='hs_context']").val());

        DepositFixForm.hsContext.pageUrl = document.URL;
        DepositFixForm.hsContext.pageName = $("title").text();
        DepositFixForm.hsContext.pageId = DepositFixForm.formContext.pageId;

        if(DepositFixForm.formContext.disableCookieSubmission){
            DepositFixForm.hsContext.hutk = '';
        }else{
            DepositFixForm.hsContext.hutk = DFUtils.getCookie("hubspotutk");
        }

        if(DepositFixForm.followUpEmailId){
            DepositFixForm.hsContext.followUpEmailId = DepositFixForm.followUpEmailId;
        }

        if(DepositFixForm.followUpEmailCampaignId){
            DepositFixForm.hsContext.followUpEmailCampaignId = DepositFixForm.followUpEmailCampaignId;
        }

        $.getJSON("https://jsonip.com/", function (data) {
            DepositFixForm.hsContext['ipAddress'] = data.ip;
        });
    },

    setupRedirectUrl: function(){
        if (DepositFixForm.redirectUrl) {
            return;
        }
        if (DepositFixForm.formContext.redirectUrl) {
            DepositFixForm.redirectUrl = DepositFixForm.formContext.redirectUrl;
            return;
        }
        if (document.location.href) {
            DepositFixForm.redirectUrl = document.location.href;
            return;
        }
        DepositFixForm.redirectUrl = DepositFixForm.fallbackRedirectUrl;
    },

    mapToPayPalPlanInterval: function(planInterval) {
        var payPalPlanInterval;
        switch (planInterval) {
            case "day":
                payPalPlanInterval = "D";
                break;
            case "week":
                payPalPlanInterval = "W";
                break;
            case "month":
                payPalPlanInterval = "M";
                break;
            case "year":
                payPalPlanInterval = "Y";
                break;
            default:
                payPalPlanInterval = "M";
                break;
        }
        return payPalPlanInterval;
    },

    updatePayPalInputValues: function() {
        var email = DepositFixForm.hubspotForm.find("input[name=email]").val();
        $("#paypal_email").val(email);
        $("#paypal_custom_data").val(DepositFixForm.getPayPalCustomData(email));
    },

    getPayPalCustomData: function(email) {
        var mode = (DepositFixForm.mode && DepositFixForm.mode == "test") ? "test" : "live";
        return "{ \"mode\": \"" + mode + "\", \"email\": \"" + email + "\", \"discountId\": \"" + DepositFixForm.discountId + "\" }";
    },

    setAmount: function (amount){
        DepositFixForm.amount = DFUtils.cleanAmount(amount);
        $(".df-final-amount").text(DFUtils.formatMoney(DepositFixForm.amount));
    },

    url: {
        getStripeDetails: function(){
            if (DepositFixForm.portalId) {
                return DepositFixForm.host + "pub/v2/stripe_details/?portalId=" + DepositFixForm.portalId + "&userId=" + DepositFixForm.userId;;
            } else {
                return DepositFixForm.host + "pub/stripe_details/?userId=" + DepositFixForm.userId;
            }
        },

        getDiscount: function(){
            if (DepositFixForm.portalId){
                return DepositFixForm.host + "pub/v2/discounts/?portalId=" + DepositFixForm.portalId;
            } else {
                return DepositFixForm.host + "pub/discounts/?userId=" + DepositFixForm.userId;
            }
        },

        getDepositFixSubmit: function(){
            return DepositFixForm.host + "payments/v2/paypal/" + DepositFixForm.portalId;
        },

        getPayPalFormUrl: function() {
            return DepositFixForm.mode && DepositFixForm.mode == "test" ?
                "https://www.sandbox.paypal.com/cgi-bin/webscr" :
                "https://www.paypal.com/cgi-bin/webscr";
        },

        getPayPalNotifyUrl: function() {
            return DepositFixForm.host + "webhooks/v2/paypal/" + DepositFixForm.portalId;
        }
    }

};

var DFUtils = {

    loadJS: function (src, callback) {
        var script = document.createElement('script'), loaded = false;
        script.setAttribute('src', src);
        script.async = true;
        document.getElementsByTagName('head')[0].appendChild(script);
        if (callback) {
            script.onreadystatechange = script.onload = function() {
                if (!loaded && (!this.readyState || this.readyState == 'complete')) {
                    loaded = true;
                    callback();
                }
            };
        }
    },

    loadAllCss: function(cssFile){
        DFUtils.loadCSS(cssFile);
        DFUtils.loadCSS(DepositFixForm.lambdaUrl + '/css?form=' + DepositFixForm.hubSpotFormId);
    },

    loadCSS: function (filename) {
        if (filename + "" == "false") {
            return;
        }
        var fileref = document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", filename);
        document.getElementsByTagName("head")[0].appendChild(fileref);
    },

    startProgress: function () {
        $("div#dfLoader").addClass("show");
        $("#df_buybtn")
            .prop("value", "Processing...")
            .prop("disabled", "disable");
    },

    stopProgress: function () {
        $("div#dfLoader").removeClass("show");
        $("#df_buybtn")
            .prop("value", DepositFixForm.submitBtnText)
            .removeAttr("disabled");
    },

    hideError: function () {
        $("#df_error").text("");
        $("#df_error").hide();
    },

    showError: function (errorMessage) {
        $("#df_error").text(errorMessage);
        $("#df_error").show();
        DFUtils.stopProgress();
    },

    logMessage: function (message, obj) {
        var formattedMessage =  "[" + DepositFixForm.portalId + "] " +
                                "[" + location.href + "] " +
                                "[" + message + "] " +
                                 (obj ? "[" + JSON.stringify(obj)  + "]" : "");
        var json = {"level": "INFO", "message": formattedMessage};
        jQuery.ajax({
            url: DepositFixForm.loggerUrl,
            type: "POST",
            headers: {
                "Content-Type": "text/plain; charset=utf-8",
            },
            data: JSON.stringify(json)
        });
    },

    initGlobalLogger: function(){
        $(document).ready(function(){
            window.onerror = function(message, url, lineNumber) {
                DFUtils.logMessage(message);
                return false;
            };
        });
    },

    getCookie: function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    },

    formatMoney: function (amount) {
        amount = Number(amount);
        var minimumFractionDigits = amount % 1 > 0 ? 2 : 0;
        return DepositFixForm.currencySign + amount.toLocaleString(undefined, {minimumFractionDigits: minimumFractionDigits});
    },

    toTwoDec: function(number) {
        return Number(number + .0049).toFixed(2);
    },

    cleanAmount: function (amount) {
        return ("" + amount).replace(/[^\d.-]/g, '');
    },

    valid: function(callback){
        var isFormValid = true;
        if (hubspot){
            // var form = hubspot.form.api.getFormForEl(document.getElementById('hsForm_' + DepositFixForm.hubSpotFormId));

            var hsForm = DepositFixForm.hubspotForm[0] || document.getElementById('hsForm_' + DepositFixForm.hubSpotFormId);

            var form = hubspot.form.api.getFormForEl(hsForm);

            if  (form) {
                var formComponent = form._getComponent();
                try{
                    formComponent.validateForm()
                        .then(function (validationResults) {
                            for (var i = 0; i < validationResults.length; i++) {
                                if  (validationResults[i].valid === false){
                                    isFormValid = false;
                                    break
                                }
                            }
                            callback(isFormValid);
                            return validationResults
                        })
                        .then(function (validationRes) {
                            console.log(validationRes);
                            return validationRes.reduce(function(accumulator, current){
                                accumulator[current.name] = {
                                    valid: current.valid,
                                    errors: current.messages,
                                    errorTypes: current.errorTypes
                                };
                                return accumulator;
                            }, {});
                        })
                        .then(function (formValidity){
                            console.log(formValidity);
                            try{
                                formComponent.setState({
                                    formValidity : formValidity
                                })
                            }catch (error) {
                                console.log(error);
                                var styleTag = $('<style>#df-card-container .input > label.error { display: block !important; }</style>')
                                $('html > head').append(styleTag);
                            }
                        });
                }
                catch (error) {
                    console.log(error);
                    var styleTag = $('<style>#df-card-container .input > label.error { display: block !important; }</style>')
                    $('html > head').append(styleTag);
                }
            }
        }
        return isFormValid
    },

};

var DFTemplate = {

    createDiscountCode: function() {
        var discountCode = "<fieldset class='form-columns-2 df-discount-area' style='display: none'>" +
            " <div class='field hs-form-field'>" +
            "   <label>" +
            "     <span>Discount Code</span>" +
            "   </label>" +
            "   <div class='input'>" +
            "     <input type='text' id='df-discount-code' name='df-discount-code' class='hs-input' autocomplete='off'/>" +
            "   </div>" +
            " </div>" +
            " <div class='field hs-form-field'>" +
            "       <label>&nbsp;</label>" +
            "   <a href='#' id='apply-discount-btn'>Apply Discount</a>" +
            " </div>" +
            "</fieldset>" +
            "<div id='df-discount-result' style='display:block;'></div>";
        return discountCode;
    },

    createFooter: function(amount) {
        var footer =
            "<span class='form-columns-1'><label class='error' id='df_error' style='font-size: 14px; color: #dc143c'></label></span>" +
            "<span class='form-columns-1'>" +
                "<div>" +
                    "<div class='actions'>" +
                        "<div class='total-amount'>" +
                            "Total: <span id='df-final-amount' class='df-final-amount'>" + DFUtils.formatMoney(DepositFixForm.amount) + "</span>" +
                        "</div>" +
                    "</div>" +
                "</div>" +
            "</span>" +
            "<div id='dfLoader'></div>" +
            "<div class='copyright'>" +
            "   <a href='https://www.depositfix.com/?ref=form'>by DepositFix</a>" +
            "</div>";
        return footer;
    }

};